import { useCallback, useEffect, useState } from 'react';

import { DateTime } from 'luxon';

import { gtagEvent } from '@components_common/gtag/gtag';
import { ContractReportNoticeModalConfig } from '@constants_iqfu';

export const useContractReportNoticeModal = (enabled: boolean) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    if (typeof window === 'undefined') return;

    const endDate = DateTime.fromISO(ContractReportNoticeModalConfig.endDate);
    if (!endDate.isValid || DateTime.now() >= endDate) return;

    const confirmed = window.localStorage.getItem(ContractReportNoticeModalConfig.storageKey);
    if (confirmed === 'true') return;

    setIsOpen(true);
  }, [enabled]);

  const onConfirm = useCallback(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(ContractReportNoticeModalConfig.storageKey, 'true');
    }
    gtagEvent({
      event: 'click_button',
      component: 'contract_report_notice_modal',
      page_label: 'company_dashboard',
      event_label: 'confirm_contract_report_alert',
    });
    setIsOpen(false);
  }, []);

  return { isOpen, onConfirm };
};
